import { getHelpUrl } from '@src/state/site/selectors'
import site from '@src/state/site/site'
import * as React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const StyledMain = styled.main`
  flex: 1;
`
const Emoji = styled.span`
  font-size: 5rem;
  padding-top: 20px;
`

const StyledLink = styled(Link)`
  color: ${props => props.theme.colors.link};
  font-size: 1rem;
  line-height: 1rem;
  padding: ${props => props.theme.spacing.sm};
  text-decoration: none;
  font-weight: bold;
  &:hover {
    text-decoration: underline;
  }
`
const StyledAnchor = styled.a`
  color: ${props => props.theme.colors.link};
  text-decoration: none;
  font-weight: bold;
  &:hover {
    text-decoration: underline;
  }
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px;
`

export const SOMETHING_WENT_WRONG_TEXT = 'It seems like something went wrong.'
export const SUPPORT_PAGE_HREF_TEST_ID = 'support-page'

const ErrorPage: React.FunctionComponent<{}> = () => (
  <StyledMain>
    <Container>
      <Emoji>😕</Emoji>
      <h1>We're sorry</h1>
      <p>{SOMETHING_WENT_WRONG_TEXT}</p>
      <p>
        We'll try to fix this right away. If the problem persists, please contact support.
      </p>
      <StyledLink to="/papers">Back to Papers</StyledLink>
      <StyledAnchor
        data-test={SUPPORT_PAGE_HREF_TEST_ID}
        href={getHelpUrl(site)}
        target="_blank"
      >
        Contact support
      </StyledAnchor>
    </Container>
  </StyledMain>
)

export default ErrorPage



// WEBPACK FOOTER //
// ./src/pages/ErrorPage/index.tsx